import { render, staticRenderFns } from "./WoltIntegrationStatus.vue?vue&type=template&id=115f9565"
import script from "./WoltIntegrationStatus.vue?vue&type=script&lang=ts"
export * from "./WoltIntegrationStatus.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports